export default __webpack_public_path__ + "static/media/181.9a4c651c.gif";